/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useState, Suspense, Fragment } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import _ from "lodash";
import * as Icon from "react-feather";
import "./App.css";
import {
  AdsignMap,
  getPathBetwenShapes,
  getPathToShape,
  loadMap,
} from "@adactiveasia/adsign-map";
import MapPinIcon from "../assets/images/map-pin.svg";
import CloseIcon from "../assets/images/close.svg";
import { s3Url } from "../utils/constants";

const Home = observer(() => {
  const sceneRef = React.useRef();
  const cameraControlsRef = React.useRef();
  const interactiveRef = React.useRef();
  const { generalStore, mapStore } = useStores();

  const [showDetailDestination, setShowDetailDestination] = useState(false);
  const [isActionEnabled, setIsActionEnabled] = useState(true);

  const historiesStorage = localStorage.getItem("histories")
    ? JSON.parse(localStorage.getItem("histories"))
    : [];

  const historiesPoisStorage = localStorage.getItem("historiesPois")
    ? JSON.parse(localStorage.getItem("historiesPois"))
    : [];

  const [newPois, setNewPois] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoadingFinish, setIsLoadingFinish] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isFormModalPoiOpen, setIsFormModalPoiOpen] = useState(false);
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);
  const [isHistoryPoiOpen, setIsHistoryPoiOpen] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);
  const [directionIndex, setDirectionIndex] = useState(0);
  const [keyword, setKeyword] = useState({
    from: "",
    to: "",
  });
  const [histories, setHistories] = useState(historiesStorage);
  const [userFloor, setUserFloor] = useState(null);

  const [popupState, setPopupState] = useState("show");

  const [isMapShowing, setIsMapShowing] = useState(false);
  const [isFloorShowing, setIsFloorShowing] = useState(false);

  const handleClosePoi = async () => {
    setIsFormModalPoiOpen(false);
    setIsHistoryPoiOpen(true);
  };

  useEffect(() => {
    generalStore.activePage = "wayfinder";
    const startLoadMap = async () => {
      await loadMap(mapStore).then(() => {
        setIsMapShowing(true);
        setTimeout(() => {
          setIsFloorShowing(true);
        }, 5000);
      });
    };
    setTimeout(() => {
      generalStore.isWayfindingRunning = false;
      setFirstInit(false);
      startLoadMap();
    });
  }, []);

  const [isTourOpen, setisTourOpen] = useState(false);
  const [startIndex, setstartIndex] = useState(0);
  const [firstInit, setFirstInit] = useState(true);

  const changeFloor = (floor) => {
    interactiveRef.current.changeActiveFloor(floor._id);
    mapStore.setActiveFloorId(floor._id);
  };

  const isShapeInPoiLocation = (poiLocation, objectName) => {
    let result = false;

    if (objectName) {
      if (poiLocation.includes(",")) {
        const poiLocations = poiLocation.split(",");
        poiLocations.forEach((poi) => {
          if (objectName.trim() === poi.trim()) result = true;
        });
      } else if (objectName.trim() === poiLocation.trim()) {
        result = true;
      }
    }

    return result;
  };

  const onPoiClick = (e) => {
    try {
      if (e.props.labels && e.props.labels.length > 0) {
        let props = e.props.labels[0];
        if (props.type === "poi") {
          const selectedPoi = mapStore.pois.find(
            ({ _id, location }) =>
              _id === props.poiId &&
              (e.props.pois
                ? e.props.pois.includes(_id)
                : isShapeInPoiLocation(location, e.name)),
          );

          if (selectedPoi) {
            if (generalStore.to !== null) {
              generalStore.from = selectedPoi;
              generalStore.setSelectedShape(e);
              mapStore.setStartShape(e);
              mapStore.setStartPOI(selectedPoi);
            } else {
              generalStore.to = selectedPoi;
              generalStore.setSelectedShapeTo(e);
              mapStore.setDestinationShape(e);
              mapStore.setDestinationPOI(selectedPoi);
            }

            generalStore.setShowMainNavigation(false);
            generalStore.setShowFloorsButton(false);
          } else {
            alert("There is no POI related to this shape");
          }
        }
      }
    } catch (e) {}
  };

  const checkPathBetweenTwoShapes = () => {
    setTimeout(() => {
      if (mapStore.destinationShape && mapStore.startShape) {
        setShowDetailDestination(true);
        // mapStore.setDestinationPOI(generalStore.to);

        // mapStore.setStartPOI(generalStore.from);
      }
    }, 500);
  };

  useEffect(() => {
    if (!firstInit)
      if (generalStore.to == null) {
        setstartIndex(1);
        setisTourOpen(true);
      } else if (generalStore.from == null) {
        setstartIndex(0);
        setisTourOpen(true);
      } else if (generalStore.to && generalStore.from) {
        checkPathBetweenTwoShapes();
      }
    if (!firstInit) {
      if (generalStore.to) {
        setstartIndex(1);
        setisTourOpen(true);
        if (mapStore.destinationShape) {
          setShowDetailDestination(true);
          // mapStore.setDestinationPOI(generalStore.to);
        }
      }
    }
  }, [generalStore.to]);

  useEffect(() => {
    if (!firstInit)
      if (generalStore.from == null) {
        setstartIndex(0);
        setisTourOpen(true);
      } else if (generalStore.to == null) {
        setstartIndex(1);
        setisTourOpen(true);
      } else if (generalStore.to && generalStore.from) {
        checkPathBetweenTwoShapes();
      }
  }, [generalStore.from]);

  useEffect(() => {
    if (mapStore?.pois && newPois.length < 1) {
      const amenitiesPoi = mapStore.pois.filter((poi) => {
        return poi.categoryName === "Amenities";
      });
      let initialPois = mapStore.pois;
      amenitiesPoi?.map((amenities) => {
        const listAmenities = amenities?.location?.split(",");
        listAmenities?.forEach((element) => {
          initialPois.push({
            name: amenities.name,
            location: element,
            categoryId: amenities.categoryId,
            categoryIds: amenities.categoryIds,
            categoryName: amenities.categoryName,
            description: amenities.description,
            firstMedias: amenities.firstMedias,
            floor: amenities.floor,
            floorId: amenities.floorId,
            floorName: amenities.floorName,
            logo: amenities.logo,
            modifiedAt: amenities.modifiedAt,
            modifiedBy: amenities.modifiedBy,
            opentime: amenities.opentime,
            phone: amenities.phone,
            priority: amenities.priority,
            secondMedias: amenities.secondMedias,
            siteId: amenities.siteId,
            subCategoryIds: amenities.subCategoryIds,
            tags: amenities.tags,
            url: amenities.url,
            __v: amenities.__v,
            _id: amenities._id,
          });
        });
        if (listAmenities.length > 1) {
          initialPois = initialPois.filter((poi) => {
            return poi.location !== amenities.location;
          });
        }
      });
      setNewPois(initialPois);
    }
  }, [mapStore.pois]);

  const handleClose = () => {
    setIsFormModalOpen(false);
    setIsHistoryOpen(true);
  };

  const handleChangeKeyword = (name, value) => {
    setKeyword({
      ...keyword,
      [name]: value,
    });
  };

  const handleClickHistory = (name, value) => {
    handleChangeKeyword(name, value);
    setIsHistoryOpen(false);
  };

  const filteredPoisTo =
    newPois.length > 0 &&
    _.orderBy(newPois, "name")
      .filter((poi) => {
        if (keyword.to) {
          return poi.name.toLowerCase().includes(keyword.to.toLowerCase());
        } else {
          return true;
        }
      })
      .filter((poi) => {
        return poi.categoryName !== "Carpark" ? poi : false;
      });

  const filteredPoisFrom =
    newPois.length > 0 &&
    _.orderBy(newPois, "name")
      .filter((poi) => {
        if (keyword.from) {
          return poi.name.toLowerCase().includes(keyword.from.toLowerCase());
        } else {
          return true;
        }
      })
      .filter((poi) => {
        return poi.categoryName !== "Carpark" ? poi : false;
      });

  const checkTags = (name) => {
    let color;
    // north: 678f6d9c36738ff306ff9261
    // west: 678f6d7836738ff306ff923f
    // convention cnter: 678f6d7836738ff306ff923f
    // east: 678f6d8336738ff306ff9249
    // tower 1: 678dc44ea1d894d9b0b25c87
    // tower 3: 678f682836738ff306ff8aa0
    // tower 4: 678f682f36738ff306ff8aa8
    // tower 2: 678f588236738ff306ff6d82
    // fountaion court: 678f6d9636738ff306ff9259
    // purple: 678f6dbd36738ff306ff9271
    // tower 5: 678f683436738ff306ff8ab0
    // sky garden: 679a5edeafacc5ba5c318372
    if (
      name[0] === "6790a9634ba3230d5b332270" ||
      name[0] === "678f6d7836738ff306ff923f"
    ) {
      color = "green";
    } else if (
      name[0] === "678f6d8336738ff306ff9249" ||
      name[0] === "678f682836738ff306ff8aa0" ||
      name[0] === "678f682f36738ff306ff8aa8"
    ) {
      color = "red";
    } else if (
      name[0] === "678f6d9c36738ff306ff9261" ||
      name[0] === "678dc44ea1d894d9b0b25c87" ||
      name[0] === "678f588236738ff306ff6d82"
    ) {
      color = "orange";
    } else if (name[0] === "678f6d9636738ff306ff9259") {
      color = "blue";
    } else if (
      name[0] === "678f6dbd36738ff306ff9271" ||
      name[0] === "678f683436738ff306ff8ab0" ||
      name[0] === "679a5edeafacc5ba5c318372"
    ) {
      color = "purple";
    } else {
      color = "dark-orange";
    }
    return color;
  };

  const handleExitWayfinding = () => {
    // reset textfield
    const currentFloorId = mapStore.activeFloorId;
    setDirectionIndex(0);
    generalStore.from = null;
    generalStore.to = null;
    mapStore.resetMap();
    interactiveRef.current.changeActiveFloor(currentFloorId);
  };

  const onTakeMeThere = async (usingLift) => {
    if (mapStore.destinationShape && mapStore.startShape) {
      const path = getPathBetwenShapes(
        mapStore,
        mapStore.startShape,
        mapStore.destinationShape,
        usingLift ? "only-disabled" : "standard",
      );
    } else if (mapStore.destinationShape) {
      mapStore.setExpanded(true);
      const path = getPathToShape(
        mapStore,
        mapStore.destinationShape,
        usingLift ? "only-disabled" : "standard",
      );
    }
  };

  const handleClickPoi = (poi, action) => {
    if (action == "from") {
      generalStore.from = poi;

      const shapeFrom = mapStore.freeShapes.find((data) => {
        if (generalStore.from.location.split(",")) {
          return generalStore.from.location.split(",").includes(data.name);
        }
        return (
          generalStore.from.location === data.name ||
          generalStore.from.location === "#" + data.name
        );
      });

      if (generalStore.historyFrom.length > 3) {
        generalStore.historyFrom = generalStore.historyFrom.pop();
      }
      if (shapeFrom) {
        mapStore.setStartShape(shapeFrom);
      }
    } else {
      generalStore.to = poi;
      const shapeTo = mapStore.freeShapes.find((data) => {
        if (poi.location.split(",")) {
          return poi.location.split(",").includes(data.name);
        }
        return poi.location === data.name || poi.location === "#" + data.name;
      });

      if (generalStore.historyTo.length > 3) {
        generalStore.historyTo = generalStore.historyTo.pop();
      }
      if (shapeTo) {
        mapStore.setDestinationShape(shapeTo);
      }
    }

    const findHistory = histories.find((x) => x === poi.name);
    if (!findHistory) {
      setHistories([...histories, poi.name]);
      localStorage.setItem(
        "histories",
        JSON.stringify([...histories, poi.name]),
      );
    } else {
      const deleteHistory = histories.filter((x) => x !== poi.name);
      setHistories([...deleteHistory, poi.name]);
      localStorage.setItem(
        "histories",
        JSON.stringify([...deleteHistory, poi.name]),
      );
    }

    generalStore.searchAction = "";
    setIsFormModalPoiOpen(false);
    setIsHistoryPoiOpen(true);
    setIsFormModalOpen(false);
    setIsHistoryOpen(true);
  };

  const targetPercentage = 100;
  const [isRunning, setIsRunning] = useState(true);

  useEffect(() => {
    if (isRunning && percentage < targetPercentage) {
      const timeout = setTimeout(() => {
        setPercentage((prev) => Math.min(prev + 1, targetPercentage));
      }, 20);

      return () => clearTimeout(timeout);
    } else if (percentage >= targetPercentage) {
      setIsRunning(false);
      setIsLoadingFinish(true);
      setFirstInit(false);
    }
  }, [percentage, isRunning, targetPercentage]);

  const checkLocation = (poi) => {
    const locations = poi.location ? poi.location : "Orchard Gateway";
    return locations;
  };

  const handlePopupState = () => {
    switch (popupState) {
      case "hide":
        setPopupState("show");
        break;
      case "show":
        setPopupState("full");
        break;
      case "full":
        setPopupState("show");
        break;
      default:
        break;
    }
  };

  return (
    <div className="App">
      <div
        className="loading-progress"
        style={{ display: loading ? "flex" : "none" }}
      >
        <div className="loader" />
        <p>Routing...</p>
      </div>

      {!isLoadingFinish && (
        <div className="loading">
          <img src={require("../assets/logo-white.png")} alt="" />
          <div className="loading-bar-wrapper">
            <div className="loading-bar" style={{ width: `${percentage}%` }} />
            <span className="loading-text">{percentage}%</span>
          </div>
        </div>
      )}
      <div className="navigation-logo">
        <img src={require("../assets/logo-white.png")} alt="" />
      </div>

      {!mapStore?.directions?.length && (
        <div className="navigation">
          {isActionEnabled && (
            <div className="navigation-card">
              <div className="point">
                <div className="from-point" />
                <div className="to-point" />
              </div>
              <div className="navigation-wrapper">
                <div className="navigation-input">
                  <div className="navigation-input-label">
                    <span
                      onClick={() => {
                        setKeyword({
                          from: "",
                          to: "",
                        });
                        setIsFormModalOpen(true);
                      }}
                    >
                      {generalStore.from
                        ? generalStore.from.name
                        : "Where are you at?"}
                    </span>
                    {generalStore.from && (
                      <Icon.X
                        onClick={() => {
                          generalStore.from = null;
                          mapStore.resetMap();
                          setDirectionIndex(0);
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="navigation-input">
                  <div className="navigation-input-label">
                    <span
                      onClick={() => {
                        setKeyword({
                          from: "",
                          to: "",
                        });
                        setIsFormModalPoiOpen(true);
                      }}
                    >
                      {generalStore.to
                        ? generalStore.to.name
                        : "Where are you going to?"}
                    </span>
                    {generalStore.to && (
                      <Icon.X
                        onClick={() => {
                          generalStore.to = null;
                          mapStore.resetMap();
                          setDirectionIndex(0);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {isActionEnabled && isFloorShowing && !mapStore?.directions?.length && (
        <div className="map-control-wrapper">
          <div className="level-control-wrapper">
            <div className="levels-container">
              {mapStore.floors.map((floor) => {
                const nameSplitted = floor.name.match(/.{1,1}/g);
                return (
                  <div
                    className={`level-btn-wrapper`}
                    onClick={() => {
                      changeFloor(floor);
                    }}
                  >
                    <div
                      className={
                        floor._id == mapStore.activeFloorId
                          ? "level-btn-active"
                          : "level-btn"
                      }
                    >
                      {nameSplitted[0]}
                      {nameSplitted[1]}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {isActionEnabled && !mapStore?.directions?.length && (
        <div
          className={`modal-popup-bottom  ${
            generalStore.to && showDetailDestination
              ? "modal-popup-bottom-is-open"
              : "modal-popup-bottom-is-close"
          } ${
            generalStore.to &&
            popupState === "hide" &&
            "modal-popup-bottom-is-hide"
          }
          ${
            generalStore.to &&
            popupState === "show" &&
            "modal-popup-bottom-is-reopen"
          }
          ${
            generalStore.to &&
            popupState === "full" &&
            "modal-popup-bottom-is-full"
          } `}
        >
          {generalStore.to && showDetailDestination ? (
            <Fragment>
              <div
                className="modal-popup-action"
                onClick={() => {
                  handlePopupState();
                }}
              >
                <div className="modal-popup-line"></div>
              </div>
              {popupState !== "hide" && (
                <div
                  className="modal-popup-close"
                  onClick={() => {
                    generalStore.to = null;
                    mapStore.resetMap();
                    setDirectionIndex(0);
                  }}
                >
                  <Icon.X />
                </div>
              )}

              <img
                src={(() => {
                  try {
                    return generalStore.to.logo
                      ? `https://d49qdhygt0dif.cloudfront.net/poi/${generalStore.to.logo}`
                      : require("../assets/default.png");
                  } catch (error) {
                    return require("../assets/default.png");
                  }
                })()}
                alt={`logo-${generalStore.to.name}`}
              />
              <div className="modal-popup-bottom-content">
                <h1 className="poi-title">
                  {generalStore.to.name.length > 40
                    ? `${generalStore.to.name.substr(0, 40)}...`
                    : generalStore.to.name}
                </h1>
                <div
                  className={`poi-detail-subtitle ${checkTags(
                    generalStore.to.tags,
                  )}`}
                >
                  <h2>
                    {mapStore
                      ? checkLocation(generalStore.to)
                      : generalStore.to.location}
                  </h2>
                </div>
                <p className="poi-detail-description">
                  {generalStore.to.description &&
                    (popupState === "full" ||
                    generalStore.to.description.length <= 120
                      ? generalStore.to.description
                      : generalStore.to.description.substring(0, 120) + "..."
                    )
                      .split("\n")
                      .map((item, index) => {
                        return (
                          <span key={index}>
                            {item}
                            <br />
                          </span>
                        );
                      })}
                </p>
                {generalStore.to.description &&
                  generalStore.to.description.length > 120 && (
                    <div
                      className="read-more"
                      onClick={() => {
                        handlePopupState();
                      }}
                    >
                      {popupState === "full" ? "See Less" : "See More"}
                      <br />
                    </div>
                  )}
              </div>

              <div className="poi-details-button">
                <button
                  className="button-left"
                  onClick={() => {
                    onTakeMeThere(false);
                    setShowDetailDestination(false);
                  }}
                >
                  Get Direction
                  <svg
                    width="10"
                    height="16"
                    viewBox="0 0 16 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.77553 13.9609L11.3425 17.1649C11.4594 17.2706 11.5527 17.3996 11.6165 17.5435C11.6804 17.6875 11.7132 17.8433 11.713 18.0008V22.1258C11.713 22.4242 11.5945 22.7103 11.3835 22.9213C11.1725 23.1323 10.8864 23.2508 10.588 23.2508V23.2508C10.2897 23.2508 10.0035 23.1323 9.79254 22.9213C9.58156 22.7103 9.46303 22.4242 9.46303 22.1258V18.5018L6.87891 17.0134"
                      fill="white"
                    />
                    <path
                      d="M8.52344 5.625C9.86963 5.625 10.9609 4.53369 10.9609 3.1875C10.9609 1.84131 9.86963 0.75 8.52344 0.75C7.17724 0.75 6.08594 1.84131 6.08594 3.1875C6.08594 4.53369 7.17724 5.625 8.52344 5.625Z"
                      fill="white"
                    />
                    <path
                      d="M4.77059 10.3816L3.46221 10.5005L2.70359 12.776C2.65549 12.9204 2.57942 13.0539 2.47972 13.1689C2.38002 13.2839 2.25864 13.3781 2.12252 13.4462C1.98639 13.5143 1.83819 13.5549 1.68637 13.5656C1.53455 13.5764 1.3821 13.5572 1.23771 13.5091V13.5091C1.08913 13.4596 0.952128 13.3804 0.834982 13.2765C0.717837 13.1725 0.622979 13.0459 0.556139 12.9043C0.4893 12.7627 0.451866 12.6089 0.446098 12.4524C0.440331 12.2959 0.466351 12.1399 0.522585 11.9937L1.74359 8.81933C1.81074 8.64479 1.92036 8.48975 2.0625 8.36822C2.20465 8.2467 2.37485 8.16253 2.55771 8.12333L6.58034 7.17383"
                      fill="white"
                    />
                    <path
                      d="M15.8034 10.602C15.7676 10.4587 15.7039 10.3238 15.616 10.2051C15.528 10.0864 15.4176 9.98613 15.2909 9.91012C15.1642 9.8341 15.0238 9.78378 14.8776 9.76203C14.7315 9.74028 14.5825 9.74753 14.4392 9.78336L11.8431 10.4325L8.2562 7.53561C7.96512 7.31775 7.62155 7.18084 7.26041 7.13881C6.89927 7.09677 6.53345 7.15111 6.20011 7.29629C5.86678 7.44147 5.57783 7.67232 5.36264 7.96537C5.14745 8.25842 5.01368 8.60323 4.97494 8.96473L3.10632 21.9375C3.05765 22.2182 3.11773 22.5069 3.27434 22.7449C3.43095 22.9829 3.67233 23.1522 3.94939 23.2186C4.22644 23.2849 4.51837 23.2433 4.76579 23.102C5.01322 22.9608 5.19756 22.7307 5.28132 22.4584L8.6312 11.0325L11.0469 12.495C11.2162 12.5972 11.404 12.6649 11.5995 12.6942C11.795 12.7236 11.9944 12.714 12.1862 12.666L14.9844 11.9662C15.1278 11.9304 15.2627 11.8668 15.3815 11.7788C15.5002 11.6909 15.6005 11.5804 15.6765 11.4538C15.7526 11.3271 15.803 11.1866 15.8247 11.0405C15.8465 10.8943 15.8393 10.7453 15.8034 10.602Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {userFloor !== generalStore.to.floor_id && (
                  <button
                    className="button-right"
                    onClick={() => {
                      onTakeMeThere(true);
                      setShowDetailDestination(false);
                    }}
                  >
                    With Lift Access
                    <svg
                      width="10"
                      height="16"
                      viewBox="0 0 18 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.54266 13.5586C3.40237 13.5596 3.26368 13.5869 3.13461 13.6388C3.00554 13.6907 2.88864 13.7663 2.79068 13.8611C2.69272 13.956 2.61563 14.0682 2.56386 14.1913C2.5121 14.3144 2.4867 14.446 2.48911 14.5785V16.9834C2.48577 17.0296 2.49254 17.0761 2.509 17.1198C2.52545 17.1635 2.55124 17.2035 2.58477 17.2374C2.6183 17.2713 2.65885 17.2983 2.7039 17.3168C2.74895 17.3352 2.79754 17.3448 2.84666 17.3448C2.89577 17.3448 2.94436 17.3352 2.98941 17.3168C3.03446 17.2983 3.07501 17.2713 3.10854 17.2374C3.14207 17.2035 3.16786 17.1635 3.18432 17.1198C3.20077 17.0761 3.20754 17.0296 3.2042 16.9834V14.79H3.37011V20.9001C3.37011 21.5267 4.33075 21.5064 4.33075 20.9001V17.3124H4.49667V20.8875C4.49667 21.4938 5.45565 21.5142 5.45399 20.8875V14.7775H5.61991V16.9708C5.61657 17.0169 5.6233 17.0631 5.63968 17.1066C5.65606 17.1501 5.68173 17.19 5.7151 17.2237C5.74847 17.2574 5.78884 17.2843 5.83368 17.3027C5.87853 17.3211 5.9269 17.3306 5.97579 17.3306C6.02468 17.3306 6.07305 17.3211 6.1179 17.3027C6.16275 17.2843 6.20311 17.2574 6.23648 17.2237C6.26985 17.19 6.29553 17.1501 6.3119 17.1066C6.32828 17.0631 6.33501 17.0169 6.33168 16.9708V14.591C6.33478 14.3212 6.22434 14.0613 6.02463 13.8683C5.82491 13.6753 5.55225 13.565 5.26651 13.5617L3.54266 13.5586Z"
                        fill="white"
                      />
                      <path
                        d="M4.4116 13.3421C4.57567 13.3421 4.73606 13.2961 4.87249 13.2101C5.00891 13.124 5.11524 13.0016 5.17802 12.8585C5.24081 12.7154 5.25724 12.5579 5.22523 12.4059C5.19322 12.254 5.11421 12.1144 4.9982 12.0048C4.88218 11.8953 4.73436 11.8207 4.57344 11.7904C4.41252 11.7602 4.24572 11.7757 4.09414 11.835C3.94255 11.8943 3.81299 11.9947 3.72184 12.1235C3.63068 12.2524 3.58203 12.4038 3.58203 12.5587C3.58203 12.7665 3.66943 12.9657 3.82501 13.1126C3.98058 13.2595 4.19159 13.3421 4.4116 13.3421Z"
                        fill="white"
                      />
                      <path
                        d="M8.2056 13.5586C8.06595 13.5604 7.92805 13.5883 7.79984 13.6406C7.67162 13.6929 7.55562 13.7686 7.45849 13.8634C7.36136 13.9582 7.28502 14.0701 7.23386 14.1929C7.18269 14.3156 7.15771 14.4466 7.16035 14.5785V16.9834C7.16035 17.0727 7.19793 17.1584 7.26482 17.2215C7.33172 17.2847 7.42245 17.3202 7.51706 17.3202C7.61167 17.3202 7.7024 17.2847 7.76929 17.2215C7.83619 17.1584 7.87377 17.0727 7.87377 16.9834V14.79H8.03969V20.9001C8.03969 21.5267 8.99867 21.5064 8.99867 20.9001V17.3124H9.16458V20.8875C9.16074 20.9491 9.17027 21.0108 9.19259 21.0688C9.21491 21.1268 9.24954 21.1799 9.29437 21.2248C9.33919 21.2696 9.39326 21.3054 9.45326 21.3299C9.51325 21.3543 9.5779 21.3669 9.64325 21.3669C9.70859 21.3669 9.77324 21.3543 9.83323 21.3299C9.89323 21.3054 9.9473 21.2696 9.99212 21.2248C10.0369 21.1799 10.0716 21.1268 10.0939 21.0688C10.1162 21.0108 10.1257 20.9491 10.1219 20.8875V14.7775H10.2878V16.9708C10.2878 17.0597 10.3252 17.145 10.3918 17.2079C10.4584 17.2708 10.5487 17.3061 10.6429 17.3061C10.737 17.3061 10.8274 17.2708 10.8939 17.2079C10.9605 17.145 10.9979 17.0597 10.9979 16.9708V14.591C10.9999 14.4575 10.9739 14.3248 10.9215 14.2007C10.8691 14.0766 10.7913 13.9635 10.6925 13.8679C10.5937 13.7723 10.4758 13.696 10.3458 13.6435C10.2157 13.5909 10.0759 13.5632 9.93442 13.5617L8.2056 13.5586Z"
                        fill="white"
                      />
                      <path
                        d="M9.07566 13.3421C9.23974 13.3421 9.40013 13.2961 9.53655 13.2101C9.67297 13.124 9.7793 13.0016 9.84209 12.8585C9.90488 12.7154 9.9213 12.5579 9.88929 12.4059C9.85728 12.254 9.77828 12.1144 9.66226 12.0048C9.54624 11.8953 9.39843 11.8207 9.23751 11.7904C9.07658 11.7602 8.90979 11.7757 8.7582 11.835C8.60662 11.8943 8.47706 11.9947 8.3859 12.1235C8.29475 12.2524 8.24609 12.4038 8.24609 12.5587C8.24609 12.7665 8.33349 12.9657 8.48907 13.1126C8.64464 13.2595 8.85565 13.3421 9.07566 13.3421Z"
                        fill="white"
                      />
                      <path
                        d="M12.8618 13.5586C12.7222 13.5606 12.5844 13.5886 12.4563 13.641C12.3282 13.6934 12.2123 13.7691 12.1152 13.8639C12.0181 13.9586 11.9418 14.0705 11.8905 14.1931C11.8393 14.3157 11.8141 14.4467 11.8166 14.5785V16.9834C11.8166 17.0276 11.8258 17.0714 11.8437 17.1123C11.8616 17.1531 11.8879 17.1903 11.921 17.2215C11.9542 17.2528 11.9935 17.2776 12.0368 17.2946C12.08 17.3115 12.1264 17.3202 12.1733 17.3202C12.2201 17.3202 12.2665 17.3115 12.3098 17.2946C12.3531 17.2776 12.3924 17.2528 12.4255 17.2215C12.4586 17.1903 12.4849 17.1531 12.5028 17.1123C12.5208 17.0714 12.53 17.0276 12.53 16.9834V14.79H12.6959V20.9001C12.6959 21.5267 13.6549 21.5064 13.6549 20.9001V17.3124H13.8208V20.8875C13.817 20.9491 13.8265 21.0108 13.8488 21.0688C13.8711 21.1268 13.9058 21.1799 13.9506 21.2248C13.9954 21.2696 14.0495 21.3054 14.1095 21.3299C14.1695 21.3543 14.2341 21.3669 14.2995 21.3669C14.3648 21.3669 14.4295 21.3543 14.4895 21.3299C14.5494 21.3054 14.6035 21.2696 14.6483 21.2248C14.6932 21.1799 14.7278 21.1268 14.7501 21.0688C14.7724 21.0108 14.782 20.9491 14.7781 20.8875V14.7775H14.944V16.9708C14.9407 17.0167 14.9474 17.0627 14.9637 17.106C14.98 17.1493 15.0056 17.189 15.0388 17.2226C15.072 17.2561 15.1122 17.2829 15.1568 17.3012C15.2014 17.3196 15.2496 17.329 15.2983 17.329C15.3469 17.329 15.3951 17.3196 15.4397 17.3012C15.4844 17.2829 15.5245 17.2561 15.5578 17.2226C15.591 17.189 15.6165 17.1493 15.6328 17.106C15.6491 17.0627 15.6558 17.0167 15.6525 16.9708V14.591C15.6565 14.3228 15.5479 14.0641 15.3505 13.8712C15.1531 13.6783 14.8829 13.5671 14.5989 13.5617L12.8618 13.5586Z"
                        fill="white"
                      />
                      <path
                        d="M13.7358 13.3421C13.8999 13.3421 14.0603 13.2961 14.1967 13.2101C14.3331 13.124 14.4395 13.0016 14.5022 12.8585C14.565 12.7154 14.5815 12.5579 14.5494 12.4059C14.5174 12.254 14.4384 12.1144 14.3224 12.0048C14.2064 11.8953 14.0586 11.8207 13.8977 11.7904C13.7367 11.7602 13.5699 11.7757 13.4184 11.835C13.2668 11.8943 13.1372 11.9947 13.0461 12.1235C12.9549 12.2524 12.9062 12.4038 12.9062 12.5587C12.9062 12.7665 12.9937 12.9657 13.1492 13.1126C13.3048 13.2595 13.5158 13.3421 13.7358 13.3421"
                        fill="white"
                      />
                      <path
                        d="M12.4536 5.53979L10.0312 3.25557L10.6368 2.67433L12.6328 4.56218V0H13.4889V4.56218L15.4915 2.67433L16.0971 3.25557L13.6697 5.53979L13.0608 6.11789L12.4536 5.53979Z"
                        fill="white"
                      />
                      <path
                        d="M5.50167 0.639833L7.92069 2.92405L7.32008 3.49746L5.32082 1.61431V6.16865H4.45807V1.61431L2.45881 3.49746L1.85156 2.92092L4.28054 0.639833L4.88281 0.0585938L5.50167 0.639833Z"
                        fill="white"
                      />
                      <path
                        d="M0 6.99219V24.0001H18V6.99219H0ZM16.3608 22.5196H1.62264V8.46017H16.3608V22.5196Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
              </div>
            </Fragment>
          ) : (
            <></>
          )}
        </div>
      )}

      {!mapStore?.directions?.length && (
        <div
          className={`modal-search  ${
            isFormModalOpen ? "modal-search-is-open" : "modal-search-is-close"
          }`}
        >
          <div
            className="modal-search-close"
            onClick={handleClose}
            style={{ paddingBottom: "10px" }}
          >
            <Icon.X />
          </div>
          <div className="search-form">
            <input
              placeholder="Where are you at?"
              onFocus={() => setIsHistoryOpen(false)}
              value={keyword.from}
              onChange={(e) => handleChangeKeyword("from", e.target.value)}
            />
            <Icon.Search />
          </div>
          <div className="modal-search-content overflow-y-auto">
            {isHistoryOpen && (
              <Fragment>
                <p>Search History</p>
                <div className="modal-search-list">
                  <ul>
                    {histories.length > 0 &&
                      histories
                        .reverse()
                        .slice(0, 30)
                        .map((history, index) => {
                          return (
                            <li key={index}>
                              <div
                                onClick={() =>
                                  handleClickHistory("from", history)
                                }
                              >
                                <Icon.Clock />
                                {history}
                              </div>
                              <button className="button-remove">
                                <Icon.X />
                              </button>
                            </li>
                          );
                        })}
                  </ul>
                </div>
              </Fragment>
            )}
            {!isHistoryOpen && (
              <div className="modal-search-list">
                <ul>
                  {filteredPoisFrom.slice(0, 50).map((poi, index) => {
                    return (
                      <li key={poi.id}>
                        <div
                          className="poi-content"
                          key={index}
                          onClick={() => handleClickPoi(poi, "from")}
                        >
                          <div className={`poi-tags ${checkTags(poi.tags)}`} />
                          <div
                            className={
                              poi.new ? "poi-name-disabled" : "poi-name"
                            }
                          >
                            {poi.name}
                          </div>
                          <div className="poi-number">#{poi.location}</div>
                          {poi.new && (
                            <div className="badge-new">Coming Soon</div>
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          <p className="help-text">Please Type Use Your Keyboard</p>
        </div>
      )}

      {!mapStore?.directions?.length && (
        <div
          className={`modal-search ${
            isFormModalPoiOpen
              ? "modal-search-is-open"
              : "modal-search-is-close"
          }`}
        >
          <div
            className="modal-search-close"
            onClick={handleClosePoi}
            style={{ paddingBottom: "10px" }}
          >
            <Icon.X />
          </div>
          <div className="search-form">
            <input
              placeholder="Where are going to?"
              onFocus={() => setIsHistoryOpen(false)}
              value={keyword.to}
              onChange={(e) => handleChangeKeyword("to", e.target.value)}
            />
            <Icon.Search />
          </div>
          <div className="modal-search-content">
            {isHistoryOpen && (
              <Fragment>
                <p>Search History</p>
                <div className="modal-search-list">
                  <ul>
                    {histories.length > 0 &&
                      histories
                        .reverse()
                        .slice(0, 10)
                        .map((history, index) => {
                          return (
                            <li key={index}>
                              <div
                                onClick={() =>
                                  handleClickHistory("to", history)
                                }
                              >
                                <Icon.Clock />
                                {history}
                              </div>
                              <button className="button-remove">
                                <Icon.X />
                              </button>
                            </li>
                          );
                        })}
                  </ul>
                </div>
              </Fragment>
            )}
            {!isHistoryOpen && (
              <div className="modal-search-list">
                <ul>
                  {filteredPoisTo.slice(0, 50).map((poi, index) => {
                    return (
                      <li key={poi.id}>
                        <div
                          className="poi-content"
                          key={index}
                          onClick={() => handleClickPoi(poi, "to")}
                        >
                          <div className={`poi-tags ${checkTags(poi.tags)}`} />
                          <div
                            className={
                              poi.new ? "poi-name-disabled" : "poi-name"
                            }
                          >
                            {poi.name}
                          </div>
                          <div className="poi-number">#{poi.location}</div>
                          {poi.new && (
                            <div className="badge-new">Coming Soon</div>
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          <p className="help-text">Please Type Use Your Keyboard</p>
        </div>
      )}
      {mapStore?.directions?.length > 0 && (
        <div className="absolute z-[40] right-4 bottom-[10px] md:bottom-32">
          <div
            className={`w-[300px] md:w-[340px] rounded-xl transition-all duration-300 ${
              isMinimized ? "h-12" : "h-auto"
            }`}
          >
            {/* Direction Box */}
            <div className="rounded-lg md:rounded-xl mb-2 bg-white backdrop-blur-xl border-4 border-black/5">
              <div className="text-white p-2 md:p-4 rounded-lg">
                {/* Header Section with Toggle Button */}
                <div className="flex justify-between items-center rounded-md p-2 md:p-3 bg-[#546AC5]">
                  <span className="text-white text-md md:text-base font-semibold">
                    DIRECTION
                  </span>
                  <button
                    className="text-white text-xl focus:outline-none"
                    onClick={() => setIsMinimized(!isMinimized)}
                  >
                    {isMinimized ? "🔼" : "🔽"}
                  </button>
                </div>

                {/* Direction Steps (Hidden when Minimized) */}
                {!isMinimized && (
                  <div className="w-[300px] md:w-[340px] px-1 md:px-3">
                    <div className="mt-4 space-y-2 text-[10px] md:text-sm">
                      {mapStore.directions.map((direction, index) => (
                        <Fragment key={index}>
                          <div
                            onClick={() => {
                              try {
                                setDirectionIndex(index);
                                interactiveRef.current.cameraFocusOnDirection(
                                  mapStore,
                                  direction,
                                );
                              } catch (e) {}
                            }}
                            className={`flex gap-1 min-h-[30px] text-[#525252] cursor-pointer ${
                              directionIndex === index
                                ? "font-semibold"
                                : "font-normal"
                            }`}
                          >
                            <span className="min-w-[35px] md:min-w-[60px]">
                              Step {index + 1} :
                            </span>
                            <span>
                              {direction.instruction.replace(
                                /<\/?[^>]+(>|$)/g,
                                "",
                              )}
                            </span>
                          </div>
                        </Fragment>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Exit Button (Hidden when Minimized) */}
            {!isMinimized && (
              <button
                onClick={handleExitWayfinding}
                className="flex h-[52px] w-[300px] md:w-[340px] items-center border-4 bg-white border-white rounded-lg overflow-hidden backdrop-blur-xl border-4 border-black/5"
              >
                <div className="flex flex-row w-full h-[40px] items-center rounded-xl mx-[6px] bg-[#ED8080]">
                  <div>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="40"
                        height="40"
                        fill="black"
                        fillOpacity="0.06"
                      />
                      <rect
                        x="25.866"
                        y="12.667"
                        width="1.33333"
                        height="18.6667"
                        transform="rotate(45 25.866 12.667)"
                        fill="white"
                      />
                      <rect
                        width="1.33333"
                        height="18.6667"
                        transform="matrix(-0.707107 0.707107 0.707107 0.707107 13.6095 12.667)"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="text-center font-semibold text-md md:text-base text-white ml-6 md:ml-16">
                    END NAVIGATION
                  </div>
                </div>
              </button>
            )}
          </div>
        </div>
      )}
      {isMapShowing && (
        <Suspense fallback={<div>Loading map...</div>}>
          <AdsignMap
            cameraControlsRef={cameraControlsRef}
            sceneRef={sceneRef}
            interactiveRef={interactiveRef}
            store={mapStore}
            onShapeClick={(e) => {
              onPoiClick(e);
            }}
            wayfindingOption={{
              wayFindingType: "play-back",
              wayfindingSpeed: 3,
            }}
            mapOption={{
              hideUserLocation: true,
              highlightColor: "#4999A3",
              isShowAllFloor: false,
              floorLabel: {
                color: "white",
                size: 5,
              },
              isDisplayMinimap: false,
              maxZoom: 0,
              minZoom: 300,
              disableZoom: false,
              disablePanning: false,
              disableRotation: false,
              showPinOnActiveShape: false,
              initialZoom: 130,
            }}
          />
        </Suspense>
      )}
      <div className="map-footer">
        <img
          src={MapPinIcon}
          style={{
            width: "10px",
            marginRight: "8px",
          }}
        />
        <span>277 Orchard Rd, Singapore 238858</span>
      </div>
    </div>
  );
});

export default Home;
